import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "back" }
const _hoisted_2 = { class: "loading" }
const _hoisted_3 = { class: "bar" }
const _hoisted_4 = { class: "percentage" }
const _hoisted_5 = { class: "data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "progress",
          style: _normalizeStyle({
            width:
              (100 * _ctx.$store.getters.getDoneRequests) /
                _ctx.$store.getters.getAllRequests +
              '%',
          })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(Math.round(
            (1000 * _ctx.$store.getters.getDoneRequests) /
              _ctx.$store.getters.getAllRequests
          ) / 10) + "% ", 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$store.getters.getDoneRequests) + "/" + _toDisplayString(_ctx.$store.getters.getAllRequests), 1)
    ])
  ]))
}